import React from 'react';

import {
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  ArrayField,
  SingleFieldList,
} from 'react-admin';

import ChipStringField from './ChipStringField';
import EditFieldLayout from '../components/layout/EditFieldLayout';

const Empty = () => '-';

const EditArrayInput = ({
  source,
  label,
  showEdit,
}: {
  showEdit: boolean;
  source: string;
  label: string;
}) => (
  <EditFieldLayout
    source={source}
    label={label}
    showEdit={showEdit}
    fieldElement={(
      <ArrayField sortable={false} source={source}>
        <SingleFieldList linkType={false} empty={<Empty />}>
          <ChipStringField />
        </SingleFieldList>
      </ArrayField>
    )}
    inputElement={(
      <ArrayInput source={source} label="" fullWidth helperText={false}>
        <SimpleFormIterator>
          <TextInput source="" label="" />
        </SimpleFormIterator>
      </ArrayInput>
    )}
  />
);

export default EditArrayInput;
